export const imageCodes = {

    furniture: {
        code: "${merchantId}_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FGroup%2064%20(1).png?alt=media&token=ed5a0072-1a63-4322-b962-c39b8f728b4e"
    },

    lighting: {
        code: "${merchantId}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FGroup%2064%20(2).png?alt=media&token=7e5d9032-c887-4362-80ab-e0230ef355dd"
    },

    accessories: {
        code: "${merchantId}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FGroup%2064%20(3).png?alt=media&token=c12a075e-f1fb-4275-9f9c-294ee5d6df63"
    },

    fashion: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FGroup%2064%20(4).png?alt=media&token=964c14db-45fd-4231-98e3-c2706c4782d6"
    },

    product1: {
        code: "${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ffurniture_malawi%20chair%202.png?alt=media&token=03ed9b6c-4d3d-4bf3-8f54-c1ae04c968af"
    },

    product2: {
        code: "${merchantId}_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Faccessories_market%20basket.jpg?alt=media&token=41453824-5a49-4c07-a970-a35f29b4e087"
    },

    product3: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Faccessories_coaster%20box.jpg?alt=media&token=1567c762-191d-423f-92ee-e3405ff2f4b1"
    },
}

export const titleCodes = {
    searchbyCategory: {
        code: "${merchantId}_tmpl_title_1",
        title: "Search by category",
    },

    searchbyBrand: {
        code: "${merchantId}_tmpl_title_2",
        title: "Search by brand",
    },

    popularSearches: {
        code: "${merchantId}_tmpl_title_3",
        title: "Popular Searches",
    },
}

export const textCodes = {
    about: {
        code: "${merchantId}_tmpl_text_1",
        text: "Welcome to mama Myanmar. mama is about strengthening the sustainability of crafters, makers and small home business through e-commerce. We are a group of local designers and gifted makers that use the best locally available materials to bring affordable luxury for your home."
    },
}